import React, { useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';

import { trackSwipeDown } from './helpers';

import './style.scss';

const Popover = ({ className, children, onClose }) => {
  const [isClosing, setIsClosing] = useState(false);
  const [isOpening, setIsOpening] = useState(false);
  const contentRef = useRef(null);
  const swipeDownCleanUp = useRef(null);

  const handleCloseTransition = useCallback(() => {
    setIsClosing(true);
    setTimeout(() => {
      onClose?.();
    }, 650);
  }, [onClose]);

  useEffect(() => {
    const timeoutId = setTimeout(() => setIsOpening(true), 0);
    return () => {
      clearTimeout(timeoutId);
      swipeDownCleanUp.current?.();
    };
  }, [swipeDownCleanUp]);

  const onSwipeStart = (event) => {
    swipeDownCleanUp.current = trackSwipeDown(event.touches[0].clientY, handleCloseTransition);
  };

  const handleWrapperClick = (e) => {
    e.stopPropagation();

    if (!contentRef.current?.contains(e.target)) {
      handleCloseTransition();
    }
  };

  return createPortal(
    <div
      className={`P-popover-wrapper ${className || ''} ${isClosing ? 'P-popover-wrapper-closing' : ''} ${isOpening ? 'P-popover-wrapper-opening' : ''}`}
      onClick={handleWrapperClick}
    >
      <div className="P-popover" ref={contentRef}>
        <span
          className="P-popover-control"
          onTouchStart={onSwipeStart}
        />

        <div className="P-popover-content">
          {children}
        </div>
      </div>
    </div>,
    document.body,
  );
};

Popover.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func,
};

export default Popover;
